
    import './styles.scoped.css';
    export default {
  "toggle": "awsui_toggle_1uo6m_180ve_97",
  "drawer-triggers": "awsui_drawer-triggers_1uo6m_180ve_102",
  "drawer": "awsui_drawer_1uo6m_180ve_102",
  "drawer-mobile": "awsui_drawer-mobile_1uo6m_180ve_112",
  "drawer-closed": "awsui_drawer-closed_1uo6m_180ve_115",
  "drawer-content": "awsui_drawer-content_1uo6m_180ve_122",
  "drawer-content-clickable": "awsui_drawer-content-clickable_1uo6m_180ve_137",
  "drawer-triggers-wrapper": "awsui_drawer-triggers-wrapper_1uo6m_180ve_148",
  "drawer-trigger": "awsui_drawer-trigger_1uo6m_180ve_102",
  "drawer-trigger-active": "awsui_drawer-trigger-active_1uo6m_180ve_166"
};
  